import { create } from 'zustand';

interface SheetState {
  id: string;
  onClose: () => void;
}

interface SheetStore {
  sheetStack: SheetState[];
  pushSheet: (id: string, onClose: () => void) => void;
  popSheet: () => SheetState | undefined;
  removeSheet: (id: string) => void;
  getTopSheet: () => SheetState | undefined;
  hasActiveSheets: () => boolean;
}

export const useSheetStore = create<SheetStore>((set, get) => ({
  sheetStack: [],

  pushSheet: (id: string, onClose: () => void) => {
    set((state) => ({
      sheetStack: [...state.sheetStack, { id, onClose }],
    }));
  },

  popSheet: () => {
    const state = get();
    const topSheet = state.sheetStack[state.sheetStack.length - 1];

    if (topSheet) {
      set((currentState) => ({
        sheetStack: currentState.sheetStack.slice(0, -1),
      }));
    }

    return topSheet;
  },

  removeSheet: (id: string) => {
    set((state) => ({
      sheetStack: state.sheetStack.filter((sheet) => sheet.id !== id),
    }));
  },

  getTopSheet: () => {
    const state = get();
    return state.sheetStack[state.sheetStack.length - 1];
  },

  hasActiveSheets: () => get().sheetStack.length > 0,
}));
